import script from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"

import "./AchievementInfo.vue?vue&type=style&index=0&id=00e25cfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e25cfc"]])

export default __exports__